import { render, staticRenderFns } from "./InvoicesModal.vue?vue&type=template&id=005147cb&"
import script from "./InvoicesModal.vue?vue&type=script&lang=js&"
export * from "./InvoicesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports